<template>
  <div>
    <material-card
      :title="title"
      data-testId="material-card-title"
      color="dover-blue">
      <v-flex
        xs12
        text-xs-right>
        <v-btn
          :disabled="progressBar.loading"
          data-testId="btn-Load"
          small
          class="mx-0 font-weight-light"
          color="dover-blue"
          @click="loadDiagnosticPushData">
          {{ $t('Load') }}
        </v-btn>
      </v-flex>
      <v-flex
        v-if="progressBar.loading"
        xs12
        md12>
        <span data-testId="span-progressBar-label">{{ progressBar.label }}</span>
        <MaglinkComponentLoadingBar
          :loading="progressBar.loading"
          :indeterminate="false"
          :max-value="progressBar.maxValue"
          :value="progressBar.currentValue"
          data-testId="MaglinkComponentLoadingBar" />
      </v-flex>
      <v-flex
        xs12
        md12
        lg12>
        <hr>
      </v-flex>
      <v-flex
        xs12
        md12
        lg12>
        <span
          data-testId="span-Fairbanks"
          class="caption grey--text font-weight-bold">
          {{ $t('Fairbanks') }}
        </span>
        <hr>
      </v-flex>
      <v-flex
        xs12
        md12
        text-xs-left>
        <span
          data-testId="span-Last-transferred--lastSentFairbanks"
          class="dover-blue-color">
          {{ $t('Last transferred').toUpperCase() + ': ' + lastSentFairbanks }}
        </span>
      </v-flex>
      <v-data-table
        :headers="headersFairbanks"
        :items="dataFairbanks"
        :no-data-text="`${ Maglink.NoDataMessage(false) }`"
        :no-results-text="`${ Maglink.NoDataMessage(true) }`"
        data-testId="data-table"
        hide-actions>
        <template
          slot="headerCell"
          slot-scope="{ header }">
          <span
            data-testId="span-header-text"
            class="dover-light-blue-color"
            v-text="header.text"/>
        </template>
        <template
          slot="items"
          slot-scope="{ item }">
          <tr :data-testId="'row-' + `${ item.id }`">
            <td data-testId="item-desc">{{ item.desc }}</td>
            <td data-testId="item-send-time">{{ item.data.sendTime }}</td>
            <td data-testId="item-uploaded">{{ item.data.uploaded }}</td>
            <td data-testId="item-waiting">{{ item.data.waiting }}</td>
            <td/>
          </tr>
        </template>
      </v-data-table>

      <v-flex
        xs12
        md12
        lg12>
        <hr>
      </v-flex>
      <v-flex
        xs12
        md12
        lg12>
        <span
          data-testId="span-Notifications"
          class="caption grey--text font-weight-bold">
          {{ $t('Notifications') }}
        </span>
        <hr>
      </v-flex>
      <v-data-table
        :headers="headersNotifications"
        :items="dataNotifications"
        :no-data-text="`${ Maglink.NoDataMessage(false) }`"
        :no-results-text="`${ Maglink.NoDataMessage(true) }`"
        data-testId="data-table-2"
        hide-actions>
        <template
          slot="headerCell"
          slot-scope="{ header }">
          <span
            data-testId="span-header-text-2"
            class="dover-light-blue-color"
            v-text="header.text"/>
        </template>
        <template
          slot="items"
          slot-scope="{ item }">
          <tr :data-testId="'row-' + `${ item.id }`">
            <td data-testId="item-desc">{{ item.desc }}</td>
            <td data-testId="item-send-time">{{ item.data.sendTime }}</td>
            <td data-testId="item-uploaded">{{ item.data.uploaded }}</td>
            <td data-testId="item-lost">{{ item.data.lost }}</td>
            <td data-testId="item-waiting">{{ item.data.waiting }}</td>
          </tr>
        </template>
      </v-data-table>
    </material-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { i18n } from '@/i18n'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    mainTimerId: 0,
    lastSentFairbanks: '--',
    dataFairbanks: [],
    headersFairbanks: [
      { sortable: false, text: i18n.t('Type') },
      { sortable: false, text: i18n.t('Transfer Date') },
      { sortable: false, text: i18n.t('Uploaded events') },
      { sortable: false, text: i18n.t('Waiting events') },
      { sortable: false, text: '' }
    ],
    dataNotifications: [],
    headersNotifications: [
      { sortable: false, text: i18n.t('Type') },
      { sortable: false, text: i18n.t('Date') },
      { sortable: false, text: i18n.t('Sent events') },
      { sortable: false, text: i18n.t('Unsent events') },
      { sortable: false, text: i18n.t('Waiting events') }
    ],
    progressBar: {
      loading: false,
      maxValue: 100,
      currentValue: 0,
      tickId: 0,
      label: ''
    }
  }),
  mounted () {
  },
  beforeDestroy () {
    this.clearTimers()
  },
  methods: {
    clearTimers () {
      this.stopMainTimer()
      this.stopProgressBarTimer()
    },
    stopProgressBarTimer () {
      clearInterval(this.progressBar.tickId)
      this.progressBar.tickId = 0
      this.progressBar.loading = false
      this.progressBar.currentValue = 0
      this.progressBar.label = ''
    },
    startProgressBarTimer () {
      // manage progressbar to show user to wait
      if (this.progressBar.tickId === 0) {
        this.progressBar.label = this.$t('Awaiting for data...')
        this.progressBar.loading = true
        this.progressBar.currentValue = 0
        this.progressBar.tickId = setInterval(this.progressBarTick, 100)
      }
    },
    progressBarTick () {
      if (this.progressBar.currentValue >= this.progressBar.maxValue) this.progressBar.currentValue = 0
      this.progressBar.currentValue += 1
    },
    startMainTimer (msecs) {
      if (msecs === undefined) {
        msecs = 60 * 1000
      }
      this.mainTimerId = setTimeout(this.updateDiagnosticPushData, msecs)
    },
    stopMainTimer () {
      clearInterval(this.mainTimerId)
      this.mainTimerId = 0
    },
    loadDiagnosticPushData () {
      this.Maglink.GetSettings('SystemSettings')
        .then(response => {
          this.systemSettings = { ...this.systemSettings, ...response.data }
          this.startProgressBarTimer()
          this.updateDiagnosticPushData()
        })
        .catch(error => (this.snack('error', error.message)))
    },
    updateDiagnosticPushData () {
      this.Maglink.GetDiagnosticPushData()
        .then(response => {
          this.stopProgressBarTimer()
          // this.startMainTimer()
          if (this.dataFairbanks.length === 0) {
            this.dataFairbanks = [
              { id: 0, desc: this.$t('Inventory'), data: {} },
              { id: 1, desc: this.$t('Delivery'), data: {} },
              { id: 2, desc: this.$t('Transaction'), data: {} },
              { id: 3, desc: this.$t('Tank Alarm'), data: {} },
              { id: 4, desc: this.$t('Sensor Alarm'), data: {} }
            ]
            if (Vue.prototype.Maglink.isPlus) {
              this.dataFairbanks.push({ id: 5, desc: this.$t('Lld Alarm'), data: {} })
            }
          }
          var lastSent = Math.max(response.data.fairbanksInventory.sendTime, response.data.fairbanksDelivery.sendTime, response.data.fairbanksTransaction.sendTime, response.data.fairbanksTankAlarm.sendTime, response.data.fairbanksSensorAlarm.sendTime, response.data.fairbanksLldAlarm.sendTime)
          this.lastSentFairbanks = this.Maglink.GetCustomDateTime(lastSent, this.systemSettings.dateFormat)

          response.data.fairbanksInventory.sendTime = this.Maglink.GetCustomDateTime(response.data.fairbanksInventory.sendTime, this.systemSettings.dateFormat)
          response.data.fairbanksDelivery.sendTime = this.Maglink.GetCustomDateTime(response.data.fairbanksDelivery.sendTime, this.systemSettings.dateFormat)
          response.data.fairbanksTransaction.sendTime = this.Maglink.GetCustomDateTime(response.data.fairbanksTransaction.sendTime, this.systemSettings.dateFormat)
          response.data.fairbanksTankAlarm.sendTime = this.Maglink.GetCustomDateTime(response.data.fairbanksTankAlarm.sendTime, this.systemSettings.dateFormat)
          response.data.fairbanksSensorAlarm.sendTime = this.Maglink.GetCustomDateTime(response.data.fairbanksSensorAlarm.sendTime, this.systemSettings.dateFormat)
          response.data.fairbanksLldAlarm.sendTime = this.Maglink.GetCustomDateTime(response.data.fairbanksLldAlarm.sendTime, this.systemSettings.dateFormat)

          this.dataFairbanks[0].data = response.data.fairbanksInventory
          this.dataFairbanks[1].data = response.data.fairbanksDelivery
          this.dataFairbanks[2].data = response.data.fairbanksTransaction
          this.dataFairbanks[3].data = response.data.fairbanksTankAlarm
          this.dataFairbanks[4].data = response.data.fairbanksSensorAlarm
          if (Vue.prototype.Maglink.isPlus) {
            this.dataFairbanks[5].data = response.data.fairbanksLldAlarm
          }

          if (this.dataNotifications.length === 0) {
            this.dataNotifications = [
              { id: 0, desc: this.$t('Email'), data: {} },
              { id: 1, desc: this.$t('Printer'), data: {} }
            ]
          }
          response.data.email.sendTime = this.Maglink.GetCustomDateTime(response.data.email.sendTime, this.systemSettings.dateFormat)
          response.data.print.sendTime = this.Maglink.GetCustomDateTime(response.data.print.sendTime, this.systemSettings.dateFormat)
          this.dataNotifications[0].data = response.data.email
          this.dataNotifications[1].data = response.data.print
        })
        .catch(error => (this.snack('error', error.message)))
    },
    snack (color, message) {
      message = this.title + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
